import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HierarchyUpdatePayload } from 'api/actions/hierarchy-update/hierarchy-update-payload';
import { HierarchyUpdatePathParameters } from 'api/actions/hierarchy-update/hierarchy-update-path-parameters';
import { HierarchyUpdateResponse } from 'api/actions/hierarchy-update/hierarchy-update-response';

type HierarchyUpdateQueryParameters = Record<string, any>;

/**
 * The path of the HierarchyUpdate action.
 */
export const hierarchyUpdateActionPath = new SweetPath<keyof HierarchyUpdatePathParameters>(
  '/api/hierarchy/update/{hierarchyId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized HierarchyUpdate actions.
 */
export default function createHierarchyUpdateAction(axios: AxiosInstance) {
  return function hierarchyUpdateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HierarchyUpdatePathParameters;
    query?: HierarchyUpdateQueryParameters;
    payload: HierarchyUpdatePayload;
  }) {
    const path = hierarchyUpdateActionPath.insert(parameters);

    return axios.request<HierarchyUpdateResponse, HierarchyUpdateResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
